import React, { useEffect, useState } from 'react';
import { fontSizes } from 'styles/vars'
import Spinner from 'shared/components/spinner';

function AppInfo() {

  const [health, setHealth] = useState(null);

  useEffect(() => {
    fetchHealth();
  }, []);

  const fetchHealth = async () => {
    const result = await fetch(`/api/health`, {
      method: 'GET',
    });
    if (result.status !== 200) {
      console.log('error fetching health:', result.status);
      return;
    }
    try {
      setHealth(await result.json());
    }
    catch (e) {
      console.error(e);
      return;
    }
  };

  const appInfo = window.env;

  if (!appInfo) {
    return <Spinner />
  }

  return (
    <>
      <div style={{ padding: '15px', display: 'flex', flexDirection: 'column' }}>
        <div style={{ fontSize: fontSizes.l, marginRight: '30px', padding: '10px' }}>
          App Info
        </div>
        <div style={{ marginLeft: '10px', marginTop: '5px' }}>
          <div style={{ fontSize: fontSizes.m, marginRight: '30px', padding: '10px' }}>
            Config
          </div>
          <div style={{ marginLeft: '10px' }}>
            {
              Object.keys(appInfo).map(k =>
                (<div key={k} style={{ padding: '5px', fontFamily: 'monospace' }}>{k}: {appInfo[k]}</div>)
              )
            }
          </div>
        </div>
        <div style={{ marginLeft: '10px', marginTop: '5px' }}>
          <div style={{ fontSize: fontSizes.m, marginRight: '30px', padding: '10px' }}>
            Health
          </div>
          <div style={{ marginLeft: '10px' }}>
            <pre style={{ fontFamily: 'monospace' }}>{JSON.stringify(health, null, 2)}</pre>
          </div>
        </div>
      </div>
    </>
  )
}

export default AppInfo;